import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import axios, { CancelToken } from "axios";

import { StatusCode } from "api/protocols";

import { showError } from "redux/actions/ui";
import { useAppDispatch } from "hooks/redux";

import { IRegister } from "../../Admin";
import DataTable from "../../../../../components/dataTable/DataTable";
import Page from "components/page/Page";
import { GetRegisters } from "api/rpc/2024-04/facilityAdmin/facility/register/register";
import { Badge } from "components/badge/Badge";

const URL = "/admin/settings/registers";
export default function Registers() {
  const history = useHistory();
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const [registers, setRegisters] = useState<IRegister[]>(undefined);

  useEffect(() => {
    const source = axios.CancelToken.source();
    void loadRegisters(source.token);
    return () => source.cancel();
  }, []);

  async function loadRegisters(token?: CancelToken) {
    if (registers === undefined) {
      setRegisters(undefined);
    }
    const res = await GetRegisters({ extended: true }, token ? false : true, token);

    if (token && token.reason) {
      return;
    }
    if (res.status !== StatusCode.OK) {
      dispatch(showError(t("Error loading registers")));
    }

    setRegisters(res.status !== StatusCode.OK ? [] : res.data);
  }

  const primaryAction = {
    content: t("New Register"),
    action: () => history.push(URL + "/new"),
  };


  function generateBadgeType(status: boolean) {
    return status ? 'error' : 'success';
  }

  return (
    <Page
      title={t("Registers")}
      subtitle={t("Register Description")}
      narrow
      primaryAction={primaryAction}
    >
      <DataTable
        columns={[
          { label: t("Name"), width: "40%" },
          { label: t("Default Card Reader ID"), width: "40%" },
          { label: t("Status"), width: "20%"},
        ]}
        loading={registers === undefined}
      >
        {registers?.map((register, index: number) => {
          return (
            <tr key={index} onClick={() => history.push(URL + "/" + String(register.id))} className="clickable">
              <td>{register.title}</td>
              <td>{register.register_group?.title}</td>
              <td><Badge type={generateBadgeType(register?.disabled)}>{register?.disabled ? "Disabled" : "Active"}</Badge></td>
            </tr>
          );
        })}
      </DataTable>
    </Page>
  );
}
